
define('widgets/preview/viewmodel',['require','exports','module','web-urls'],function (require, exports, module) {
    function preview() {
        var self = this;
        var g2mmUrl = require('web-urls').get('gotoMeetMeUrl');

        self.createPreviewUri = function (settings) {
            var previewUriArray = [];
            if (settings.properties.avatar) {
                previewUriArray.push('avatarUrl=' + encodeURIComponent(settings.properties.avatar));
            }

            if (settings.properties.background) {
                previewUriArray.push('theme=' + encodeURIComponent(settings.properties.background));
            }

            if (settings.properties.location) {
                previewUriArray.push('location=' + encodeURIComponent(settings.properties.location));
            }

            if (settings.properties.name) {
                previewUriArray.push('name=' + encodeURIComponent(settings.properties.name));
            }

            if (settings.properties.title) {
                previewUriArray.push('title=' + encodeURIComponent(settings.properties.title));
            }

            if (settings.properties.about) {
                previewUriArray.push('profileUrl=' + encodeURIComponent(settings.properties.about));
            }

            return encodeURI(g2mmUrl + '/_preview?' + previewUriArray.join('&'));
        };

        self.activate = function (settings) {
            self.settings = settings;
            self.settings.properties.personalUrl = self.createPreviewUri(settings);
        };
    }

    module.exports = preview;
});

